import { configSchema } from './configSchema';

const viteEnvVars = {
  app: {
    env: import.meta.env.VITE_APP_ENV,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
    featureFlagOverrides: import.meta.env.DEV
      ? import.meta.env.VITE_FEATURE_FLAG_OVERRIDES || undefined
      : undefined,
  },
  billing: {
    workspacePlanOverride:
      import.meta.env.VITE_WORKSPACE_PLAN_OVERRIDE || undefined,
  },
  external: {
    googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    linkedinClientId: import.meta.env.VITE_LINKEDIN_CLIENT_ID,
    linkedinRedirectUri: import.meta.env.VITE_LINKEDIN_REDIRECT_URI,
    slackClientId: import.meta.env.VITE_SLACK_CLIENT_ID || undefined,
    slackRedirectUri: import.meta.env.VITE_SLACK_REDIRECT_URI || undefined,
    posthogKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
    posthogHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    stiggPublishableKey: import.meta.env.VITE_STIGG_PUBLISHABLE_KEY,
  },
};

// Runtime validation of Vite environment variables
export const config = configSchema.parse(viteEnvVars);
